import { IPatient, v2 } from '../../..';
import { getGender } from './helpers/getGender';

type PatientParts = Pick<IPatient, 'pds' | 'staffPreferredGender' | 'practice' | 'odsCode'> & {
    nhsNumber?: string;
};

export const patientAdapter = (patient: v2.Patient): PatientParts => {
    const { nhsNumber, pdsVersion, gpPracticeCode, gpPracticeName, genderPreferences } = patient;

    const staffPreferredGender = genderPreferences?.flatMap(({ genderId }) => {
        const gender = getGender(genderId, null);
        return gender ? [gender] : [];
    });

    const result: PatientParts = {
        nhsNumber: nhsNumber ?? undefined,
        odsCode: gpPracticeCode ?? undefined,
        practice: gpPracticeName ?? undefined,
        staffPreferredGender,
    };

    if (pdsVersion) {
        result.pds = {
            versionId: pdsVersion,
        };
    }

    return result;
};
